module.exports = __webpack_public_path__ + "img/partner_16.aa55c349.png";